import type { PartialBlockRegistry } from '@eshop/templates/blocks/types';

import { SoftCommercePanelLayoutBlock } from './panelLayout';

export const softCommerceBlocks: PartialBlockRegistry = {
  panel: {
    SoftCommercePanelLayout: SoftCommercePanelLayoutBlock,
  },
};
